import { useMutation } from "@tanstack/react-query";
import { createQuizBatch } from "../services/quizBatchService";

export function useCreateQuizBatch(options = {}) {
  return useMutation({
    mutationFn: createQuizBatch,
    ...options,
  });
}
